import { useEffect, useState } from "react";
import { Gauge } from "lucide-react";
import { api } from "@/lib/api";
import { HAZARD_LABEL } from "@/lib/hazard";

const pct = (v) => (v == null ? "—" : `${v}%`);

// Internal health metric: share of anomaly sites flagged in the last 7 days that no agency has confirmed.
export const FalsePositiveCard = () => {
  const [m, setM] = useState(null);
  useEffect(() => { api.falsePositive().then(setM).catch(() => {}); }, []);
  if (!m) return null;
  return (
    <section className="border border-white/10 bg-atlas-surface/70 p-4 mb-8" data-testid="false-positive-card">
      <div className="flex items-center gap-2 mb-3">
        <Gauge className="w-4 h-4 text-amber-300" />
        <span className="text-[10px] font-mono uppercase tracking-widest text-amber-300">Internal · unconfirmed anomalies (last {m.days} days)</span>
      </div>
      <div className="flex flex-wrap gap-8 font-mono">
        <div>
          <div className="text-3xl text-atlas-red" data-testid="fp-resolved-pct">{pct(m.false_positive_pct)}</div>
          <div className="text-[9px] uppercase tracking-widest text-atlas-secondary">false positives = misses / (hits + misses)</div>
        </div>
        <div><div className="text-3xl text-emerald-400" data-testid="fp-confirmed">{m.confirmed}</div><div className="text-[9px] uppercase tracking-widest text-atlas-secondary">confirmed</div></div>
        <div><div className="text-3xl text-atlas-red" data-testid="fp-misses">{m.misses}</div><div className="text-[9px] uppercase tracking-widest text-atlas-secondary">misses</div></div>
        <div><div className="text-3xl text-amber-300" data-testid="fp-still-elevated">{m.still_elevated}</div><div className="text-[9px] uppercase tracking-widest text-atlas-secondary">still elevated (not scored)</div></div>
        <div><div className="text-3xl text-atlas-cyan" data-testid="fp-pending">{m.pending}</div><div className="text-[9px] uppercase tracking-widest text-atlas-secondary">window pending</div></div>
        <div><div className="text-3xl text-white" data-testid="fp-unconfirmed-pct">{pct(m.unconfirmed_pct)}</div><div className="text-[9px] uppercase tracking-widest text-atlas-secondary">not (yet) confirmed · {m.sites} sites</div></div>
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 mt-3 text-[10px] font-mono text-atlas-secondary">
        {m.by_hazard.map((h) => (
          <span key={h.hazard} data-testid={`fp-hazard-${h.hazard}`}>{HAZARD_LABEL[h.hazard] || h.hazard}: <span className="text-white">{h.misses}</span> miss · <span className="text-amber-300">{h.still_elevated}</span> elevated · <span className="text-atlas-cyan">{h.pending}</span> pending of {h.sites}</span>
        ))}
      </div>
    </section>
  );
};
